import { BkRoutes } from 'bkng';

import { id } from './id/id';

export const domains: BkRoutes = [
    {
        path: "id",
        label: "Organization Domains by ID",
        children: id,
    },
];
